import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { IUserMast } from "../../models/UserMast";
import { EmptyUser } from "./EmptyUser";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IUserMast
}

export const UserMast = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyUser, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyUser, open: false })
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}
